export class ObjUtils {
  static clearObj = (obj) => {
    Object.keys(obj).forEach((key) => delete obj[key]);
  };
}
